<div class="card">
  <div class="card-body">
    <div class="mb-56">
      <h4 class="mb-56 d-inline" *ngIf="isAdd">Add Category</h4>
      <h4 class="mb-56 d-inline" *ngIf="!isAdd">Edit Category</h4>
      <div class="button-row mb-4 d-inline float-end">
        <button
          *ngIf="isAdd"
          mat-raised-button
          class="me-8 mb-8"
          [routerLink]="['../category']"
          color="primary"
        >
          Category List
        </button>
        <button
          *ngIf="!isAdd"
          mat-raised-button
          class="me-8 mb-8"
          [routerLink]="['../../category']"
          color="primary"
        >
          Category List
        </button>
      </div>
    </div>
    <form
      [formGroup]="categoryForm"
      (ngSubmit)="onSubmit()"
      enctype="multipart/form-data"
      #myForm="ngForm"
    >
      <!-- Category name -->
      <mat-form-field class="w-100 fs-16" appearance="outline">
        <mat-label>Category Name</mat-label>
        <input
          matInput
          type="text"
          formControlName="name"
          placeholder="Enter the category"
        />
        <mat-error
          *ngIf="
            categoryForm.controls['name'].hasError('required') ||
            myForm.submitted
          "
        >Name can not be empty.</mat-error
        >
      </mat-form-field>

      <!-- Sticker size -->
      <mat-form-field class="w-25 fs-16" appearance="outline">
        <mat-label>Sticker Size</mat-label>
        <mat-select formControlName="stickerFlag">
          <mat-option [value]="1">25 * 25</mat-option>
          <mat-option [value]="0">50 * 50</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-error
        *ngIf="
          (categoryForm.controls['stickerFlag'].hasError('required') &&
            categoryForm.controls['stickerFlag'].touched) ||
          (myForm.submitted && myForm.invalid)
        "
        >Sticker Size can not be empty</mat-error
      >

      <!-- Allow Linked Products -->
      <div class="linked-toggle-section mb-3">
        <mat-slide-toggle color="primary" formControlName="allowLinkedProducts" class="theme-slide-toggle">
          <span class="fs-15 fw-medium text-dark">Allow Linked Products</span>
        </mat-slide-toggle>
        <div class="text-muted fs-12 mt-1">
          When enabled, products created under this category can have linked sub-products/components with separate warranties.
        </div>
      </div>

      <!-- Image -->
      <div class="my-3">
        <button
          type="button"
          mat-raised-button
          (click)="fileInput.click()"
          class="mb-3"
        >
          Choose File
        </button>
        <input
          hidden
          (change)="onFileSelected($event)"
          #fileInput
          accept="image/*"
          type="file"
          id="file"
          formControlName="image"
        />
        <br />
        <div>
          <img [src]="preview" class="preview mb-2" />
        </div>
      </div>

      <!-- Form Actions -->
      <div class="d-flex align-items-center gap-2 mt-4">
        <!-- Add Mode Submit -->
        <button
          *ngIf="isAdd"
          [disabled]="categoryForm.errors || categoryForm.invalid || isSubmitting"
          mat-raised-button
          color="primary"
          type="submit"
        >
          Submit
        </button>

        <!-- Edit Mode Submit (Renamed from Edit to Submit) -->
        <button
          *ngIf="!isAdd"
          [disabled]="categoryForm.invalid || isSubmitting"
          mat-raised-button
          color="primary"
          type="button"
          (click)="onEdit()"
        >
          Submit
        </button>

        <!-- Cancel Button -->
        <button
          type="button"
          mat-stroked-button
          (click)="onCancel()"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
